module.exports = __webpack_public_path__ + "static/media/app.da33b5f2.png";